import React from 'react';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core';
import http from '../../../config/http';
import { AUTH_SET_PASSWORD } from '../../../config/api';
import { _route } from '../../../utils';

const useStyles = makeStyles(() => ({
  textField: {
    padding: '0px!important',
    fontSize: '16px!important',
    fontFamily: 'Inter !important',
    fontWeight: '400',
    marginTop: '8px!important',
    transition: '.3s',
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
      lineHeight: '1em',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      // border: '1px solid #5433FF',
    },
    '& .MuiFormHelperText-root': {
      letterSpacing: '0 !important',
      fontFamily: 'Inter',
      margin: '6px 0 0 0 !important',
      fontWeight: '500',
    },
    '& .MuiOutlinedInput-root .MuiInputBase-input': {
      borderRadius: '8px',
      background: '#fff',
      fontSize: '14px !important',
      // border: '1px solid #D0D5DD',
      boxShadow: ' 0px 1px 2px rgb(16 24 40 / 5%)',
      padding: '13.5px 14px',
      transition: '.3s',
      '&:focus': {
        transition: '.3s',
        outline: '0',
        boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%)',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
    },
  },
}));
const buttonStyles = {
  borderRadius: '10px',
  boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  width: '100%',
  padding: '10px 14px',
  color: '#fff',
  transition: '0.2s',
  marginTop: '5px',
  fontWeight: '500',
  backgroundColor: '#5433ff',
  borderColor: '#5433ff',
  border: '1px solid #5433ff',
  fontFamily: 'Inter',
  letterSpacing: '0',
  textTransform: 'inherit',
  '&:hover': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:focus': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:visited': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
};

export default function SetPasswordForm() {
  const classes = useStyles();
  const routeParams = useLocation().search;

  const passwordRegExp = /^.{8,}$/;

  const RegisterSchema = Yup.object().shape({
    password: Yup.string().required('Password is required').matches(passwordRegExp, {
      message: 'Password must be at least eight characters',
    }),
  });

  const formik = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: async (e, { setSubmitting }) => {
      const searchParamsData = new URLSearchParams(routeParams);
      const token = searchParamsData.get('token');

      const payload = {
        password: values.password,
        token,
      };

      try {
        await http.post(AUTH_SET_PASSWORD, payload).then((res) => {
          if (res.data.status === 'success') {
            toast.success('Password set successful');
            window.location = _route('growz.overview');
          } else {
            toast.warn(res.data.message);
          }
        });
      } catch (err) {
        toast.error(err.response.data.message);
      }
      setSubmitting(false);
    },
  });

  const { errors, touched, handleSubmit, values, isSubmitting, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <div className="customLabel">Password</div>
          <TextField
            fullWidth
            type="password"
            placeholder="Enter new password here..."
            {...getFieldProps('password')}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
            InputLabelProps={{ shrink: false }}
            className={classes.textField}
          />

          <LoadingButton fullWidth size="large" type="submit" sx={buttonStyles} variant="contained" loading={isSubmitting}>
            Continue
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
